import { render, staticRenderFns } from "./v-cookies-banner.vue?vue&type=template&id=4afb8b74"
import script from "./v-cookies-banner.vue?vue&type=script&lang=js"
export * from "./v-cookies-banner.vue?vue&type=script&lang=js"
import style0 from "./v-cookies-banner.vue?vue&type=style&index=0&id=4afb8b74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports